export default "__VITE_ASSET__DVhrEOxC__"